var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedPortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.46447 1.46447C2.40215 0.526784 3.67392 0 5 0C6.32608 0 7.59785 0.526784 8.53553 1.46447C9.47322 2.40215 10 3.67392 10 5C10 6.32608 9.47322 7.59785 8.53553 8.53553C7.59785 9.47322 6.32608 10 5 10C3.67392 10 2.40215 9.47322 1.46447 8.53553C0.526784 7.59785 0 6.32608 0 5C0 3.67392 0.526784 2.40215 1.46447 1.46447ZM5 0.625C3.83968 0.625 2.72688 1.08594 1.90641 1.90641C1.08594 2.72688 0.625 3.83968 0.625 5C0.625 6.16032 1.08594 7.27312 1.90641 8.09359C2.72688 8.91406 3.83968 9.375 5 9.375C6.16032 9.375 7.27312 8.91406 8.09359 8.09359C8.91406 7.27312 9.375 6.16032 9.375 5C9.375 3.83968 8.91406 2.72688 8.09359 1.90641C7.27312 1.08594 6.16032 0.625 5 0.625ZM7.10646 2.91497C7.22242 3.0428 7.21279 3.24043 7.08495 3.35639C6.49165 3.89455 6.07676 4.35033 5.73169 4.88894C5.38538 5.42949 5.10085 6.06676 4.78362 6.9777C4.74796 7.08009 4.66178 7.15668 4.55591 7.18007C4.45004 7.20345 4.33962 7.1703 4.26414 7.09246L2.90065 5.68621C2.7805 5.5623 2.78356 5.36446 2.90747 5.24432C3.03137 5.12418 3.22921 5.12723 3.34935 5.25114L4.36467 6.29829C4.62828 5.5982 4.88967 5.04465 5.20543 4.55178C5.59048 3.95077 6.04785 3.45329 6.66505 2.89346C6.79288 2.77751 6.99051 2.78714 7.10646 2.91497Z",
    fill: "#F58220"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedPortal);
export default __webpack_public_path__ + "static/media/checked-portal.3e85a0e0e87a878d7ff98408fdd3f8bd.svg";
export { ForwardRef as ReactComponent };